import React from "react";
import PropTypes from "prop-types";

const WarningText = ({ children }) => (
  <div
    style={{
      padding: "8px 20px",
      border: "solid 1px #efe4b1",
      backgroundColor: "#fffbdd",
      color: "#353535",
      fontSize: 16,
      lineHeight: 1.31,
    }}
  >
    {children}
  </div>
);

WarningText.propTypes = {
  children: PropTypes.node,
};

WarningText.defaultProps = {
  children: "",
};

export default WarningText;
